import { IRatingSummary } from 'shared/repositories/dailyrent/entities/response/RatingSummary';

import type { IState } from '../../store';

/**
 * Селектор для получения краткой информации о рейтинге (для мини-виджета)
 */
export const selectRatingSummary = (state: IState): IRatingSummary | null => {
  return state.dailyrentData?.ratingSummary || null;
};
